import React from 'react';

const InputCpf = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const handlePaste = (e) => {
    const cpfCopiado = e.clipboardData.getData('Text');

    if (cpfCopiado.length == 11 && cpfCopiado.match(/^\d+$/)) {
      e.target.value = cpfCopiado.replace(
        /^(\d{3})(\d{3})(\d{3})/gi,
        '$1.$2.$3-'
      );
    }
  };

  const handleInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.-]/g, '');
  };

  const handleKeyDown = (e) => {
    let invalidChars = ['.', '-'];
    const key = e.key;

    if (invalidChars.includes(key)) {
      e.preventDefault();
    }

    if (key !== 'Backspace' && key !== 'Delete') {
      //verifica se a tecla precionada nao e um backspace e delete
      var i = e.target.value.length; //aqui pega o tamanho do input
      if (i === 3 || i === 7)
        //aqui faz a divisoes colocando um ponto no terceiro e setimo indice
        e.target.value = e.target.value + '.';
      else if (i === 11)
        //aqui faz a divisao colocando o traço no decimo primeiro indice
        e.target.value = e.target.value + '-';
    }
  };

  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className='input-container'>
        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={className}
          pattern='\d{3}.\d{3}.\d{3}-\d{2}'
          placeholder='000.000.000-00'
          maxLength='14'
          autoComplete='off'
          onInput={(e) => handleInput(e)}
          onKeyDown={(e) => handleKeyDown(e)}
          onPaste={(e) => handlePaste(e)}
          {...rest}
        />
      </div>
      <div className='mensagem legenda'>{legenda} {msgErro}</div>
    </div>
  );
};

export default InputCpf;
